import SolutionCardHoverScene from "./SolutionCardHoverScene";

// Orchestrateur fin (pointer/resize/rAF) autour de SolutionCardHoverScene, sur le même principe
// que SolutionsCards3D. Le survol est écouté sur .card-item (l'article englobant) et non sur le
// canvas lui-même : le stretched-link de .card-solution-content couvre toute la carte et
// intercepterait sinon les évènements pointer du canvas.
export default class SolutionCardHover3D {
	constructor(canvas, { card, modelUrl }) {
		this.canvas = canvas;
		this.hoverTarget = canvas.closest(".card-item") || canvas;
		this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		this.raf = null;

		this.scene = new SolutionCardHoverScene({ canvas, card, modelUrl });

		this._onPointerMove = (e) => {
			if (this.reducedMotion) return;
			const rect = canvas.getBoundingClientRect();
			const x = (e.clientX - rect.left) / rect.width - 0.5;
			const y = (e.clientY - rect.top) / rect.height - 0.5;
			this.scene.setHoverTilt(x, y);
		};
		this._onPointerLeave = () => this.scene.resetTilt();
		this._onResize = () => this.scene.resize();

		this.hoverTarget.addEventListener("pointermove", this._onPointerMove);
		this.hoverTarget.addEventListener("pointerleave", this._onPointerLeave);
		window.addEventListener("resize", this._onResize);

		this._tick = () => {
			this.scene.update();
			this.raf = requestAnimationFrame(this._tick);
		};

		this.ready = this._init();
	}

	async _init() {
		await this.scene.load();
		this._tick();
	}

	destroy() {
		cancelAnimationFrame(this.raf);
		this.hoverTarget.removeEventListener("pointermove", this._onPointerMove);
		this.hoverTarget.removeEventListener("pointerleave", this._onPointerLeave);
		window.removeEventListener("resize", this._onResize);
		this.scene.destroy();
	}
}
